import { Component, OnInit } from '@angular/core';
import { AuthService, LanguageService } from './services';
import { Language } from 'aws-sdk/clients/support';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { IdleTimeoutService } from './services/idle-timeout/idle-timeout.service';

@Component({
  selector: 'esc-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  public moduleName;
  constructor(
    language : LanguageService,
    title: Title,
    private idleTimeoutService: IdleTimeoutService,
    private authService: AuthService
  ) {
    language.initLocale();
    title.setTitle(environment.appName)
  }

  ngOnInit(): void {
    this.authService.whenLoggedIn.subscribe(user => {
      if (user) {
        this.waitForSettingsAndStartIdle();
      } else {
        this.idleTimeoutService.stopWatching();
      }
    });
  }

  // Wait for settings to be provided during authentication before starting the idle timeout service
  private waitForSettingsAndStartIdle(): void {
  const interval = setInterval(() => {
    const settings = localStorage.getItem('settings');
    if (settings) {
      clearInterval(interval);
      this.idleTimeoutService.startWatching();
    }
  }, 500);
}
}
